import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgWomanCelebrateFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#woman-celebrate-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E8E8E8",
        d: "M28.002 56c15.463 0 28-12.536 28-28s-12.537-28-28-28c-15.464 0-28 12.536-28 28s12.536 28 28 28"
    }), /*#__PURE__*/ React.createElement("mask", {
        id: `woman-celebrate-fidelity-low_svg__b-${id}`,
        width: 57,
        height: 56,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: 'alpha'
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#EDE9E8",
        d: "M28.002 56c15.463 0 28-12.536 28-28s-12.537-28-28-28c-15.464 0-28 12.536-28 28s12.536 28 28 28"
    })), /*#__PURE__*/ React.createElement("g", {
        mask: `url(#woman-celebrate-fidelity-low_svg__b-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#231F20",
        d: "M8.479 18.178c1.14-1.371 1.477-2.214 1.49-3.543.011-1.256.95-3.386 2.262-4.187 1.923-1.174 3.379-.6 4.542-.14.734.29 1.352.535 1.897.265 2.212-1.097 4.548.68 5.579 3.086.61 1.425 1.535 2.49 2.786 2.658 1.81.242 3.51 1.436 3.653 3.395.114 1.568.504 2.003.684 2.024l-17.096 9.898-.686.403-4.4 2.542c1.578-3.203 1.317-5.094-.526-7.187-.26-.294-.523-.574-.78-.846-1.571-1.663-2.889-3.058-1.339-5.964.24-.448.736-.997 1.174-1.482.334-.37.635-.702.76-.922"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4C875B",
        fillRule: "evenodd",
        d: "M47.487 16.648s.304-.305.508-.305c.203 0 .406.203.406.407s-.305.406-.305.406z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#D06E61",
        fillRule: "evenodd",
        d: "M47.893 18.98s0 .806-.609 1.22c-.61.414-1.015.407-1.015.407l.656-1.53zM47.893 20.505s0 .807-.609 1.22c-.61.415-1.015.407-1.015.407l.656-1.53z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E0B699",
        fillRule: "evenodd",
        d: "M47.292 23.114s-.724.435-1.353.94l-.04.032c-.356.291-.676.601-.807.864-.366.734-2.566 1.835-2.566 1.835l.19 3.902-1.015-.39-3.751-1.446.177-4.268v-3.397c0-.395.12-.78.342-1.107 1.238-1.826 1.858-4.306 1.858-4.306.18.043.323.127.432.242.777.807-.066 3.061-.066 3.061l-.366 1.469.733-.367s1.889-1.224 3.708-2.264c1.487-.847 2.927-1.572 3.257-1.407.732.367-1.1 2.202-1.1 2.202v.367c.054 1.03 0 2.203 0 2.203 2.199 0 .367 1.835.367 1.835",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EED1C0",
        fillRule: "evenodd",
        d: "m40.693 19.076-.366 1.469c.733 1.835-.367 3.304-.367 3.304.367-1.469-.366-3.672-.366-3.672 1.268-1.585 1.202-3.638 1.165-4.162.778.807-.066 3.061-.066 3.061M47.292 23.114s-.724.435-1.353.94l-1.17-6.14c1.486-.847 2.926-1.572 3.256-1.408.732.368-1.1 2.203-1.1 2.203v.367c.257 1.233 0 2.203 0 2.203 2.199 0 .367 1.835.367 1.835M45.9 24.086c-.357.29-.677.601-.808.863-.366.735-2.566 1.836-2.566 1.836l.19 3.901-1.414-.596c.285-.692-.147-2.185-.01-2.459.204-.406-.203-1.424-.203-1.424 2.234.305 4.57-2.237 4.57-2.237a.7.7 0 0 1 .24.116",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4C875B",
        fillRule: "evenodd",
        d: "M39.87 17.055s.102.102.204 0c.08-.081.29-.74.372-1.007a.4.4 0 0 0 .006-.225l-.073-.294s-.407 1.017-.508 1.526",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M40.976 14.681c0-.442.404-.897.852-.897h4.112c.448 0 .852.444.852.886v9.955c0 .442-.449.875-.896.875H41.86c-.448 0-.885-.444-.885-.886z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        fillRule: "evenodd",
        d: "M40.82 14.664c0-.562.464-1.02 1.033-1.02h4.06c.57 0 1.034.458 1.034 1.02v9.96c0 .563-.464 1.02-1.034 1.02h-4.06c-.57 0-1.033-.457-1.033-1.02zm.222 0v9.96c0 .442.364.802.811.802h4.06c.448 0 .813-.36.813-.801v-9.961c0-.442-.365-.801-.813-.801h-4.06a.807.807 0 0 0-.811.8",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M40.975 15.951h-.24v.481h.24zM47.032 16.587h-.24v.984h.24zM40.975 16.672h-.24v.7h.24zM40.975 17.612h-.24v.7h.24z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#9B8A84",
        fillRule: "evenodd",
        d: "M41.702 21.173c0-.349.283-.631.633-.631h3.227a.632.632 0 1 1 0 1.262h-3.227a.63.63 0 0 1-.633-.631",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E8E8E8",
        fillRule: "evenodd",
        d: "M43.91 20.006a2.263 2.263 0 0 1-2.261-2.265 2.263 2.263 0 0 1 2.262-2.265 2.263 2.263 0 0 1 2.261 2.265 2.263 2.263 0 0 1-2.261 2.265",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        fillRule: "evenodd",
        d: "M43.886 19.135c-.51 0-.917 0-.917-.482 0-.498.432-.9.965-.9s.965.402.965.9c0 .482-.407.482-.917.482h-.096M43.934 17.57c-.409 0-.74-.31-.74-.692s.331-.691.74-.691.74.31.74.691c0 .382-.331.692-.74.692",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E1AEA1",
        fillRule: "evenodd",
        d: "M47.893 20.505s0 .407-.305.509c-.118.04-.444.035-.714.024-.13-.006-.246-.013-.32-.018a.35.35 0 0 1-.223-.096c-.063-.063-.114-.164-.063-.317l.379-.488.003-.003.16-.207a.56.56 0 0 1 .57-.208c.245.061.513.5.513.804",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4C875B",
        fillRule: "evenodd",
        d: "m46.89 21.03-.015.008c-.13-.006-.247-.013-.321-.018a.35.35 0 0 1-.223-.095c-.063-.064-.113-.165-.063-.318l.379-.488.003-.003c.054-.048.357-.284.634.085.304.406.127.538-.393.828",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E1AEA1",
        fillRule: "evenodd",
        d: "M47.893 18.98s0 .407-.305.509c-.118.04-.444.035-.714.024-.13-.006-.246-.013-.32-.019a.35.35 0 0 1-.223-.095c-.063-.063-.114-.165-.063-.317l.379-.489.003-.002.16-.207a.56.56 0 0 1 .57-.209c.245.062.513.5.513.805",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4C875B",
        fillRule: "evenodd",
        d: "m46.89 19.503-.015.01-.321-.019a.35.35 0 0 1-.223-.095c-.063-.064-.113-.165-.063-.318l.379-.488.003-.003c.054-.048.357-.284.634.085.304.406.127.538-.393.828",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E1AEA1",
        fillRule: "evenodd",
        d: "M48.041 21.57c.102.194.06.43-.102.581-.17.16-.43.328-.718.235-.112-.035-.224-.011-.29-.016a.32.32 0 0 1-.202-.084c-.056-.055-.102-.144-.056-.278l.342-.427q0-.002.003-.003l.145-.181a.51.51 0 0 1 .513-.183c.133.032.274.183.365.356",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4C875B",
        fillRule: "evenodd",
        d: "m47.217 22.378-.014.009-.281-.017a.3.3 0 0 1-.195-.083c-.055-.055-.1-.145-.055-.279l.331-.427.003-.003c.047-.042.313-.249.556.074.267.356.111.471-.345.726",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        fillRule: "evenodd",
        d: "M40.578 57.26c-.877 0-1.732-.181-2.458-.406-.43-.136-.818-.287-1.132-.423-.573-.249-.926-.455-.926-.455L26.21 32.909s4.132.178 6.71 1.728c1.746 1.05 3.493 5.247 3.493 5.247l.095-10.33a1.79 1.79 0 0 1 2.434-1.098l5.941 1.371.014.07q.01.042.021.105.01.043.021.102.016.073.031.16c.068.383.285 1.01.572 1.842 1.471 4.256 4.778 13.826-.746 22.82q-.116.19-.248.368a4.6 4.6 0 0 1-1.74 1.49q-.004.002-.003.004c-.709.342-1.467.472-2.21.473z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        fillRule: "evenodd",
        d: "m37.838 56.181-.376.585-.911-1.788 1.043.052q.127.582.244 1.151M39.18 45.374l-.046 2.009-1.707-1.045z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        fillRule: "evenodd",
        d: "m39.134 47.382-1.707-1.045 1.754-.964zM41.276 40.826l-.046 2.009-1.707-1.045z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        fillRule: "evenodd",
        d: "m41.23 42.836-1.707-1.045 1.753-.964zM42.81 39.032l-.203-1.999 1.824.822z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        fillRule: "evenodd",
        d: "m44.431 37.855-1.62 1.177-.204-1.999zM45.167 47.082l-1.214-1.597 1.981-.259zM44.632 33.545l-1.993-.149 1.124-1.66zM43.177 50.532l-1.993-.148 1.125-1.661zM36.112 42.419l-1.085 1.687-.911-1.789zM39.483 36.889l-1.707-1.045 1.754-.964zM41.673 55.828l-1.214-1.596 1.982-.26zM46.423 42.688l-1.993-.148 1.125-1.662zM39.684 52.282l-1.993-.148 1.125-1.661zM39.955 30.175l-1.085 1.688-.911-1.789z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        fillRule: "evenodd",
        d: "M44.795 54.928q-.116.189-.248.367a5.3 5.3 0 0 1-1.74 1.49c-.003 0-.003.004-.003.004-1.55.748-3.34.482-4.684.066-.43-.136-.817-.287-1.132-.423l-1.048-8.214c.102.206 1.946 3.883 4.664 2.862 2.794-1.05 4.279-21.252 4.279-21.252q-.001.001.014.07.01.042.02.105.01.043.021.102l.032.16c.416 2.34 6.427 13.913-.175 24.663",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EED1C0",
        d: "M6.139 38.59c3.288-2.645 9.506-5.468 12.204-6.549h3.414c2.234.382 7.15 1.571 11.55 4.013.949 6.93 1.61 19.435-.983 30.942l-20.29.235c1.096-1.907 2.881-5.959 1.819-10.587-1.328-5.785-3.604-10.235-7.714-18.054"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EED1C0",
        d: "M23.906 33.154c0 .401-1.435.727-3.204.727s-3.205-.326-3.205-.727c0-.402 1.435-.728 3.204-.728s3.205.326 3.205.727"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        fillRule: "evenodd",
        d: "m34.092 40.757.322-1.983 1.547 1.273z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        d: "M15.21 33.084c2.72 1.007 8.59.72 11.596 0 .979.279 3.765 1.284 7.087 3.07.811 8.683 8.278 27.42 4.19 31.093H11.66c-6.084 0-6.542-27.28-5.469-28.863 1.074-1.583 5.655-3.67 9.02-5.3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "m20.33 39.576-1-1.74-.998 1.74zM18.177 50.268l-1-1.74-.999 1.74zM30.121 34.329l.095.04-1.063 1.653-.91-1.789zM36.537 48.385l-.402.7h.58zM38.193 55.203l-1.043-.053.91 1.789.377-.585q-.117-.57-.244-1.15M17.498 42.171l-.902 1.794-1.093-1.682zM14.444 54.656l.901-1.793-1.995.111zM34.4 53.474l.902-1.793-1.995.11zM33.287 44.51l-.86 1.814 1.993-.158zM30.275 57.016l.86-1.814 1.132 1.655zM13.59 45.162l-.86 1.814 1.992-.158zM21.714 37.959l.86-1.814 1.132 1.655zM26.518 40.014l.046-2.009-1.753.964zM24.41 48.696l-.046 2.01-1.707-1.046zM6.82 40.666l.046-2.009-.89.489q-.061.39-.11.937zM23.81 43.393l-.158-2.003-1.647 1.138zM21.499 52.081l.157 2.003-1.804-.865zM26.295 47.252l-.205-2 1.824.823zM23.937 55.944l.204 2 1.62-1.178zM6.596 47.904l-.204-2 1.824.822zM15.072 34.257l.204 2 1.62-1.178zM33.317 37.857l-.767 1.856-1.215-1.596zM30.396 50.404l.768-1.855-1.982.259zM13.62 38.51l-.769 1.854-1.214-1.596zM29.692 41.356l.869 1.809-1.994-.148zM28.407 53.856l-.869-1.81-1.124 1.662zM9.994 42.007l.869 1.81-1.993-.148zM19.346 45.642l.911 1.788 1.085-1.687zM9.28 38.548l-.91-1.789 1.996.101z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        fillRule: "evenodd",
        d: "M9.634 66.071c-2.372-2.995-3.464-11.157-3.79-17.86-.244-5.028-.056-9.235.346-9.829a3 3 0 0 1 .156-.205q.064.023.128.05c4.33 1.714 6.165 4.503 7.53 6.576.732 1.113 1.33 2.02 2.104 2.445 1.056.58 2.262.79 3.488 1.004 1.349.235 2.722.475 3.948 1.214.703.424 1.395 1.204 2.12 2.022 1.384 1.56 2.888 3.256 4.807 2.856 2.744-.57 2.735-7.75 2.724-16.926l-.002-1.635q.346.179.7.368c.281 3.01 1.361 7.225 2.483 11.604 2.05 7.999 4.238 16.538 1.944 19.246a2.4 2.4 0 0 1-.236.244H11.659c-.76 0-1.433-.426-2.025-1.174",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        d: "M29.152 33.92c-4.094 1.536-8.047 1.497-13.77.728 6.962 2.153 16.639 1.698 14.908-.22z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EED1C0",
        d: "m17.467 25.749 5.55.4.82 7.166-6.37-.459z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        fillRule: "evenodd",
        d: "m23.307 28.704-.29-2.492-5.55-.464v6.23c.532.226.945.315 1.275.332h.088l.04-.002c.382-.025.88-.163 1.528-.5a8 8 0 0 0 1.097-.709c.625-.471 1.442-1.567 1.812-2.395",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        d: "M3.686 59.903C2.826 56.376 5.189 39.32 6.19 38.24c7.802 4.03 9.02 16.337 9.664 17.992s10.38 6.766 10.952 8.565c.573 1.799-5.584 4.318-7.66 4.318-3.722.288-14.602-5.686-15.461-9.212"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        fillRule: "evenodd",
        d: "m24.876 67.142-.067.039-.007-.073zM8.525 39.836q.372.327.72.678h-1.11zm10.517 21.595-1-1.74-.999 1.74zm-3.734 4.389.902-1.794-1.995.112zM6.401 44.903l.901-1.793-1.995.11zm7.794 11.954-.86 1.813 1.993-.158zM7.472 50.35l-.047 2.01-1.707-1.046zm-.618 10.357-.047 2.009L5.1 61.672zm-.761-4.824-.157-2.003-1.647 1.138zm16.428 9.364-.157-2.003-1.647 1.138zM6.998 57.6l.204 2 1.62-1.178zm7.227-7.395-.768 1.855-1.214-1.596zm-2.153 10.69-.768 1.856-1.214-1.596zm-.603-5.383-.87-1.81-1.124 1.662zm.94 10.274-.87-1.81-1.124 1.661zm3.798 2.618 1.96.396-.639-1.904zM9.15 46.58l.911 1.788 1.085-1.687z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        fillRule: "evenodd",
        d: "M21.818 62.6c-.67.528-1.062.836-1.878.464-.292-.134-.6-.36-.973-.633-1.448-1.063-3.864-2.837-10.058-2.63-.269 0-.535.01-.797.02-2.78.1-5.062.184-3.876-11.502q.022-.22.039-.437c-.629 4.918-1.027 10.225-.59 12.021.86 3.527 11.74 9.5 15.463 9.212 2.075 0 8.232-2.519 7.659-4.318-.218-.686-1.767-1.852-3.635-3.124a9.5 9.5 0 0 0-1.354.927",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#B8BFC1",
        strokeLinecap: "round",
        strokeWidth: 0.768,
        d: "m11.826 36.054 4.005-2.414"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E0B699",
        d: "M24.158 22.937c.855.045 1.603-.943 1.67-2.208s-.572-2.328-1.427-2.373-1.602.943-1.67 2.208.572 2.328 1.427 2.373M12.908 25.597c-.847.13-1.688-.781-1.879-2.033-.19-1.252.341-2.371 1.188-2.5.847-.13 1.688.781 1.88 2.033.19 1.252-.342 2.371-1.19 2.5"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#4C875B",
        d: "m25.39 21.414 2.683 1.478-2.61 1.594zM12.072 24.004l-1.934 2.375 3.017.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#EED1C0",
        d: "M23.218 17.634s-1.732-6.336-6.781-5.32l-.023.005-.023.005c-5.042 1.084-4.296 6.634-4.296 6.634s.66 6.869 1.476 8.167c.58.917 2.023 2.23 3.353 2.773.545.225 1.077.39 1.516.482.701.14 1.206.145 1.584.089l.04-.009.012-.002.011-.002.012-.003q.002 0 .011-.002l.04-.009c.371-.094.837-.305 1.418-.713.298-.211.625-.486.96-.808 1.084-1.046 2.21-2.996 2.388-4.157.23-1.516-1.901-8.078-1.901-8.078z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#EED1C0",
        strokeLinecap: "round",
        strokeWidth: 0.661,
        d: "M18.494 20.994c.246 1.107.56 1.283.928 1.67.367.389-.1 1.223-.456 1.322"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#231F20",
        d: "M21.553 20.566c-.405.13-.687.505-.817.098a.77.77 0 1 1 1.465-.47c.13.407-.244.243-.648.372M15.359 21.882c-.415.09-.628.405-.72-.011a.77.77 0 0 1 .585-.92.77.77 0 0 1 .916.59c.091.416-.367.25-.782.34"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#231F20",
        fillRule: "evenodd",
        d: "M20.759 17.848c-.492.13-1.03.252-1.598.34.093-1.456-.36-3.15-.537-3.67.11 1.652.018 2.879-.223 3.762-2.117.19-4.533-.193-6.544-2.276.955-2.857 3.274-4.653 6.892-4.63 2.894.02 4.992 3.476 5.68 5.201-.216-.18-.59.007-1.19.306-.517.258-1.201.599-2.095.86a9.5 9.5 0 0 0-.682-1.543q.227.931.297 1.65",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M22.049 24.977c-1.356.609-3.262 1.24-4.725.89.145 1.331 1.623 2.455 2.77 2.11.955-.287 1.743-1.33 1.955-3"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M21.741 25.079c-.142.581-.634 1.298-1.901 1.588-1.117.256-1.899-.17-2.38-.687a2 2 0 0 1-.036-.216c1.321.323 2.993-.142 4.317-.685",
        clipRule: "evenodd"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#7A9EBF",
        d: "M53.32 21.378a2.76 2.76 0 0 1-.44-3.878 2.76 2.76 0 0 1-3.879.441 2.76 2.76 0 0 1 .441 3.879 2.76 2.76 0 0 1 3.879-.442M43.696 9.566a2.76 2.76 0 0 1-.441-3.879 2.76 2.76 0 0 1-3.879.442 2.76 2.76 0 0 1 .441 3.878 2.76 2.76 0 0 1 3.879-.441M37.377 12.503c-1.744-1.388-2.091-3.851-.778-5.503-1.313 1.652-3.792 1.866-5.535.48 1.743 1.386 2.09 3.85.777 5.501 1.314-1.651 3.792-1.866 5.536-.479M28.61 6.496c-1.376-1.095-1.664-3.024-.641-4.308-1.023 1.284-2.967 1.438-4.343.343 1.376 1.095 1.663 3.024.641 4.309 1.022-1.285 2.967-1.439 4.343-.344M35.188 5.494c-.776-.618-.939-1.707-.362-2.431-.577.724-1.674.811-2.45.193.776.618.939 1.707.362 2.432.577-.725 1.674-.812 2.45-.194M32.126 15.556c-.777-.618-.939-1.706-.362-2.431-.577.725-1.674.812-2.45.194.776.618.938 1.706.361 2.431.577-.725 1.674-.812 2.45-.194"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `woman-celebrate-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgWomanCelebrateFidelityLow;
